import { requestAbortReason, withRequestBudget } from "./request-budget.js";
export class SharedOperationMap {
    operations = new Map();
    run(key, options, defaultTimeoutMs, start) {
        if (options?.signal?.aborted)
            return Promise.reject(requestAbortReason(options.signal));
        const operation = this.operations.get(key) ?? this.begin(key, start);
        return this.wait(key, operation, options, defaultTimeoutMs);
    }
    begin(key, start) {
        const controller = new AbortController();
        const operation = {
            controller,
            waiters: 0,
            settled: false,
            promise: undefined
        };
        operation.promise = Promise.resolve()
            .then(() => start(controller.signal))
            .finally(() => {
            operation.settled = true;
            if (this.operations.get(key) === operation)
                this.operations.delete(key);
        });
        this.operations.set(key, operation);
        return operation;
    }
    async wait(key, operation, options, defaultTimeoutMs) {
        operation.waiters += 1;
        try {
            return await withRequestBudget(options, defaultTimeoutMs, () => operation.promise);
        }
        finally {
            operation.waiters -= 1;
            if (operation.waiters === 0 && !operation.settled && this.operations.get(key) === operation) {
                this.operations.delete(key);
                operation.controller.abort();
            }
        }
    }
}
